<!--Header -->
<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.red" *ngIf="!showConfirmed && !renewalErrorSubmitting">
  <mat-card-content>
    <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-start items-start sm:items-center">
      <mat-icon class="medium-icon m-24">badge</mat-icon>
      <h2 class="f-s-20" *ngIf="!workerLicense.isRenewal">Apply For a Worker Permit</h2>
      <h2 class="f-s-20" *ngIf="workerLicense.isRenewal">Renew Your Worker Permit</h2>
      <h2 class="f-s-20 flex items-center gap-2" *ngIf="workerLicense.licenseId && showForm"> {{workerLicense.licenseId}}
        <button mat-icon-button (click)="sharedService.copyToClipboard(workerLicense.licenseId)"
                matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
          <mat-icon>content_copy</mat-icon>
        </button>
      </h2>
      <span class="hidden sm:flex-1"></span>
      <button mat-raised-button type="button" class="sm:self-auto" color="primary" *ngIf="viewEdit  && ((workerLicenses.length > 1) ||(workerLicenses.length == 1 && workerLicense.status != 'Pending'))" (click)="toggleView()">Close</button>
    </div>
  </mat-card-content>
</mat-card>
<!--End of Header -->

<div *ngIf="showForm" class="flex w-full flex-col gap-2" style="overflow-x: auto;">
  <mat-stepper class="readable-stepper" [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #WorkerStepper [selectedIndex]="step"
    (selectionChange)="changeStep($event)">
    <!-- Start here section -->
    <mat-step>
      <ng-template matStepLabel>
        <span class="f-s-14">Start Here</span>
      </ng-template>
      <div class="p-b-8 flex flex-col gap-2">
        <span class="f-s-20" *ngIf="!workerLicense.isRenewal">Thank you for your interest in applying for a psilocybin worker
          permit through the Oregon Psilocybin Services -
          Training Program, Licensing, and Compliance system (TLC). </span>

        <span class="f-s-20" *ngIf="workerLicense.isRenewal">Thank you for your interest in applying to renew your psilocybin worker
          permit through the Oregon Psilocybin Services -
          Training Program, Licensing, and Compliance system (TLC). </span>

        <div style="padding-top: 2em" class="flex flex-col lg:flex-row gap-3">
          <div class="flex flex-col gap-2">
            <strong>Psilocybin Worker Permit Requirements:</strong>
            <ul class="flex flex-col gap-2">
              <li class="f-s-16">
                Must be 21 years of age or older
              </li>
              <li class="f-s-16">
                Must pass a criminal background check
              </li>
              <li class="f-s-16">
                Must pay a worker permit fee
              </li>
            </ul>


          </div>

          <div class="flex flex-col gap-2">
            <strong>Who must have a valid psilocybin worker permit?</strong>
            <span class="p-l-24">
              An individual who is a licensee or a licensee representative must have a valid worker permit if the
              individual participates in:
            </span>
            <div style="padding-left: 1em" class="flex flex-col gap-3">
              <ul class="flex flex-col gap-2">
                <li class="f-s-16">
                  The provision of psilocybin services at a licensed premises.
                </li>
                <li class="f-s-16">
                  The possession, manufacturing, securing or selling of psilocybin products at a
                  licensed premises.
                </li>
                <li class="f-s-16">
                  The recording of the possession, manufacturing, securing or selling of psilocybin
                  products at a licensed premises.
                </li>
                <li class="f-s-16">
                  The verification of any document described in ORS 475A.445.
                </li>
              </ul>

            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row gap-3">
            <div style="padding-top: 2em" class="flex flex-col gap-2 w-full md:w-1/2">
            <strong>The completed application packet contains the following:</strong>
            <ul class="flex flex-col gap-2">
              <li class="f-s-16">
                Completed and signed worker permit application
              </li>
              <li class="f-s-16">
                Uploaded copy of the front and back of a valid, unexpired government-issued photo
                identification for the applicant
              </li>
            </ul>

          </div>
          <div style="padding-top: 2em" *ngIf="workerLicense.isRenewal" class="flex flex-col gap-2 w-full md:w-1/2">
            <strong>Timely and Untimely Applications:</strong>
            <ul class="flex flex-col gap-2">
              <li class="f-s-16">
                <strong>Timely: </strong>Renewal applications that are complete, submitted according to requirements,
                and submitted at least 60 days before the permit expires will be considered timely under OPS rules.
                Applicants who submit timely applications may continue to operate on an expired permit if OPS is unable
                to process the renewal application prior to the permit expiration date. Incomplete renewal applications
                will not be considered timely unless they are made complete <strong>at least 60 days</strong> before the permit expires.
              </li>
              <li class="f-s-16">
                <strong>Untimely: </strong>Renewal applications that are submitted <strong>less than 60 days</strong> before the permit
                expires will be considered untimely under OPS rules. Applicants who submit untimely applications are prohibited
                from continuing to operate on an expired permit if OPS is unable to process the renewal application prior to the
                permit expiration date. Applicants are prohibited from exercising permit privileges on the date their permit expires
                if OPS is unable to process their renewal application before the expiration date and the renewal application is untimely.
              </li>
            </ul>

          </div>
        </div>

        <div style="padding-top: 2em" class="flex flex-row">
          <div class="flex flex-col gap-2">
            <strong>Important Notes: </strong>
            <ul class="flex flex-col gap-2">
              <li class="f-s-16">
              Please review each section of the application to ensure it is complete
              </li>
              <li class="f-s-16">
                A fee page will describe when and how to submit the worker permit fee which may be paid
                online, by mail, or in-person
              </li>
              <li class="f-s-16" *ngIf="!workerLicense.isRenewal">
                <strong>Incomplete and Insufficient Application Statuses:</strong>
              </li>
              <div style="padding-left: 1em;" *ngIf="!workerLicense.isRenewal" class="flex flex-col gap-2">
                <li class="f-s-16" *ngIf="showNewIncompleteDates(workerLicense.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing
                  required information (e.g., the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your
                  application complete. You have 30 days from the initial date you are notified to complete your
                  application. If you fail to do so, the application will be closed.
                </li>
                <li class="f-s-16" *ngIf="showNewIncompleteDates(workerLicense.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application
                  or site inspection does not meet requirements outlined in statute or rule. If the application is
                  insufficient,
                  we will notify you by email to give you an opportunity to meet requirements. You will have 30 days from
                  the initial date you are notified to meet requirements, or your application will be denied.
                </li>

                <li class="f-s-16" *ngIf="!showNewIncompleteDates(workerLicense.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing
                  required information (e.g., the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your
                  application complete. You have 90 days from the initial date you are notified to complete your
                  application. If you fail to do so, the application will be closed.
                </li>
                <li class="f-s-16" *ngIf="!showNewIncompleteDates(workerLicense.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application
                  or site inspection does not meet requirements outlined in statute or rule. If the application is
                  insufficient,
                  we will notify you by email to give you an opportunity to meet requirements. You will have 90 days from
                  the initial date you are notified to meet requirements, or your application will be denied.
                </li>
              </div>
            </ul>

          </div>
        </div>


        <div style="padding-top: 2em" class="flex flex-col gap-2">
          <span *ngIf="!workerLicense.isRenewal">
            <strong>When you click the continue button at the bottom of this page, you will proceed to the psilocybin
              worker permit application. </strong> The application automatically saves in TLC. You may exit the
            application and come back later to complete and submit the application, if needed.
          </span>
          <span *ngIf="workerLicense.isRenewal">
            <strong>When you click the continue button at the bottom of this page, you will proceed to the psilocybin
              worker permit renewal application. </strong> The application automatically saves in TLC. You may exit the
            application and come back later to complete and submit the renewal application, if needed.
          </span>
        </div>
        <div style="padding-top: 2em;" class="flex flex-col gap-2">
          <span>
            <strong>DISCLAIMER:</strong> Psilocybin remains a schedule I drug under the federal Controlled Substances
            Act. Applicants are responsible for
            making their own determinations regarding the legal risks associated with participating in this program. The
            information you provide in your application
            materials, including applicant name, is subject to disclosure under Oregon's public records laws.
          </span>
        </div>

      </div>
      <div class="p-t-16 flex flex-row w-full md:w-1/2">
        <button mat-raised-button matStepperNext *ngIf="!canApplyAgain">Continue</button>
        <button mat-flat-button type="button" color="primary" *ngIf="showStartButton && canApplyAgain"
          (click)="startApplication()">Start Application</button>
      </div>
    </mat-step>
    <!-- End of Start here section -->

    <!-- Start of Personal Information -->
    <mat-step [stepControl]="applicantForm" *ngIf="workerLicenses.length >= 1">
      <form [formGroup]="applicantForm">
        <ng-template matStepLabel>
          <span *ngIf="applicantForm.disabled">Applicant Information</span>
          <span class="text-red-400" *ngIf="!applicantForm.valid && applicantForm.touched && !applicantForm.disabled">
            Applicant Information Incomplete</span>
          <span *ngIf="applicantForm.valid || !applicantForm.touched && !applicantForm.disabled">Applicant Information</span>
        </ng-template>
        <div class="flex flex-col">
          <div class="flex flex-col 2xl:flex-row gap-2">
            <mat-card class="w-full 2xl:w-1/2">
              <mat-card-title>
                <div class="flex flex-col lg:flex-row">
                  <span class="flex-1 f-s-20">Applicant Information</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <span id="legalNameLabel"><strong>Legal Name</strong></span>
                  <div class="flex flex-col md:flex-row gap-2">
                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="First" formControlName="legalFirstName" aria-describedby="legalNameLabel">
                      <mat-error role="alert" *ngIf="applicantForm.get('legalFirstName').invalid">
                        Error: Please enter your first name
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="Last" formControlName="legalLastName" aria-describedby="legalNameLabel">
                      <mat-error role="alert" *ngIf="applicantForm.get('legalLastName').invalid">
                        Error: Please enter your last name
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput placeholder="Middle" formControlName="legalMiddleName" aria-describedby="legalNameLabel">
                    </mat-form-field>
                  </div>

                  <span id="preferredNameLabel"><strong>Preferred Name</strong></span>
                  <div class="flex flex-col md:flex-row gap-2">
                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="First" formControlName="preferredFirstName" aria-describedby="preferredNameLabel">
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="Last" formControlName="preferredLastName" aria-describedby="preferredNameLabel">
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput placeholder="Middle" formControlName="preferredMiddleName" aria-describedby="preferredNameLabel">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col">
                    <span id="priorNamesLabel"><strong>Prior Names and Aliases</strong></span>
                    <span>This information is used for the purposes of the background check</span>
                    <div class="flex flex-col lg:flex-row gap-2">
                      <mat-form-field class="w-full md:w-[80%]">
                        <input matInput placeholder="Name, other name, any other names"
                          formControlName="alternateNames" aria-describedby="priorNamesLabel">
                      </mat-form-field>

                      <mat-form-field>
                        <mat-label>Date of Birth</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="dob" matInput [matDatepicker]="dob"
                          [max]="sharedService.today" />
                        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                        <mat-datepicker #dob>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="applicantForm.get('dob').value > sharedService.today">
                          Error: Please choose an earlier date.
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('dob').hasError('required')">
                          Error: Date of birth is required
                        </mat-error>
                        <mat-error role="alert" *ngIf="!applicantForm.get('dob').hasError('required') && !isAgeValid(21)">
                          Error: Date of Birth must be 21+
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col">
                    <span id="ssnLabel"><strong>*SOCIAL SECURITY NUMBER DISCLOSURE:</strong></span>
                    <span style="padding-top: 1em; padding-left: 1em"><strong>• </strong>As part of your application for
                      an initial or renewal license, Federal and State laws require you to provide your Social Security
                      Number (SSN), if you have one,
                      to Oregon Psilocybin Services for child support enforcement purposes (42 USC § 666(a)(13) & ORS
                      25.785). If you are an applicant or licensee and you have an SSN but fail to provide your SSN, Oregon Psilocybin
                      Services may refuse to process your application.
                      Your SSN will be used only for child support enforcement purposes unless you confirm your
                      agreement that OPS can use it for administrative purposes as well.
                    </span>

                    <span style="padding-top: 1em; padding-left: 1em">
                      <strong>IMPORTANT NOTE: If you do not have a social security number, you may still be licensed or permitted by Oregon Psilocybin Services.</strong>
                    </span>

                    <span style="padding-top: 1em; padding-left: 1em"><strong>• </strong>
                      Based on our authority under OAR 333-333-4100, we are requesting your voluntary consent to use
                      your SSN for the following administrative purposes only: to positively confirm your identity
                      during the criminal records check. Oregon
                      Psilocybin Services will not deny you any rights, benefits or privileges otherwise provided by law
                      if you do not consent to use of your SSN for these administrative purposes (5 USC§ 552(a)).
                      <strong>Please check the appropriate box next to the social security field indicating whether you
                        consent or do not consent.</strong>
                    </span>
                    <div class="flex flex-col lg:flex-row gap-4 justify-start items-center">
                      <mat-form-field class="w-full md:w-[25%]">
                        <input matInput placeholder="SSN" formControlName="ssn" mask="000-00-0000" aria-describedby="ssnLabel">
                        <mat-error role="alert" *ngIf="validateSsn()">
                          Error: SSN is Required
                        </mat-error>
                      </mat-form-field>
                      <mat-checkbox formControlName="noSsn">
                        I don't have a social security number
                      </mat-checkbox>
                    </div>
                    <span>Do you consent to use of SSN for purposes of confirming identity during a criminal records
                      check?</span>
                    <mat-error role="alert" *ngIf="validateSsnAttestation()">
                      Error: Consent choice is Required
                    </mat-error>

                    <mat-checkbox  formControlName="ssnAttestation" (click)="changeAttestation(true)">
                     <span class="f-s-16">Yes</span>
                    </mat-checkbox>
                    <mat-checkbox  formControlName="ssnNoAttestation" (click)="changeAttestation(false)">
                      <span class="f-s-16">No</span>
                    </mat-checkbox>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                Contact Information
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <div class="flex flex-col lg:flex-row gap-2">
                    <div class="flex flex-col gap-2 w-full lg:w-1/2">
                      <span id="primaryPhoneLabel"><strong>Primary Phone</strong></span>
                      <mat-form-field>
                        <input matInput placeholder="Phone" formControlName="phone" mask="(000) 000-0000 000000"
                          [validation]="false" aria-describedby="primaryPhoneLabel">
                        <mat-error role="alert" *ngIf="applicantForm.get('phone').hasError('required')">
                          Error: A primary phone number is required
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('phone').hasError('pattern')">
                          Error: Phone should match this format: 999-999-9999 x1234
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="flex flex-col gap-2 w-full lg:w-1/2">
                      <span id="alternatePhoneLabel" class="f-2-20"><strong>Alternate Phone</strong></span>
                      <mat-form-field>
                        <input matInput placeholder="Alt Phone" formControlName="alternatePhone"
                          mask="(000) 000-0000 000000" [validation]="false" aria-describedby="alternatePhoneLabel">
                        <mat-error role="alert" *ngIf="applicantForm.get('alternatePhone').hasError('pattern')">
                          Error: Phone should match this format: 999-999-9999 x1234
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col lg:flex-row gap-2">
                    <div class="flex flex-col gap-2 w-full lg:w-1/2">
                      <span id="primaryEmailLabel" class="f-2-20"><strong>Primary Email Address</strong></span>
                      <mat-form-field>
                        <input matInput placeholder="Email" formControlName="email" aria-describedby="primaryEmailLabel">
                        <mat-error role="alert" *ngIf="applicantForm.get('email').hasError('required')">
                          Error: Please enter an email address
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('email').hasError('email')">
                          Error: This doesn't look like a valid email address
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="flex flex-col gap-2 w-full lg:w-1/2">
                      <span id="confirmEmailLabel" class="f-2-20"><strong>Confirm Email Address</strong></span>
                      <mat-form-field>
                        <input matInput placeholder="Confirm Email" formControlName="confirmEmail" aria-describedby="confirmEmailLabel">
                        <mat-error role="alert" *ngIf="validateEmail()">
                          Error: Email does not match
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col lg:flex-row gap-2">
                    <div class="flex flex-col gap-2 w-full lg:w-1/2">
                      <span id="preferredLanguageLabel" class="f-2-18"><strong>Preferred Language</strong></span>
                      <mat-form-field>
                        <input matInput placeholder="Language" formControlName="language" aria-describedby="preferredLanguageLabel">
                      </mat-form-field>
                    </div>
                  </div>

              <div class="flex flex-col">
                <span id="affiliatedLicensesLabel" class="f-2-20"><strong>Other OPS Licenses or Permits</strong></span>
                <mat-checkbox formControlName="previousLicense">
                  <span class="f-s-16">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
                </mat-checkbox>
                <div class="m-t-8 flex flex-col" *ngIf="this.applicantForm.get('previousLicense').value">
                  <span class="f-s-16">Please provide the license id(s) for each Oregon Psilocybin Services license.</span>
                  <mat-form-field>
                    <input matInput formControlName="affiliatedLicenses" aria-describedby="affiliatedLicensesLabel">
                    <mat-label style="color:red" *ngIf="applicantForm.get('affiliatedLicenses').value == ''">Affiliated Licenses*</mat-label>
                    <mat-label style="color:grey" *ngIf="applicantForm.get('affiliatedLicenses').value != ''">Affiliated Licenses</mat-label>
                  </mat-form-field>
                </div>
              </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <mat-card>
            <mat-card-title>Address</mat-card-title>
            <mat-card-content>
              <div class="flex flex-col">
                <span id="physicalAddressLabel" class="f-s-16"><strong>Physical Address</strong></span>
                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:w-[50%]">
                    <input matInput placeholder="Street Apt/Unit/Suite" formControlName="physicalStreet" aria-describedby="physicalAddressLabel">
                    <mat-error role="alert" *ngIf="applicantForm.get('physicalStreet').invalid">
                      Error: Please provide a street
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-[50%]">
                    <input matInput placeholder="City" formControlName="physicalCity" aria-describedby="physicalAddressLabel">
                    <mat-error role="alert" *ngIf="applicantForm.get('physicalCity').invalid">
                      Error: Please provide a city
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full">
                    <mat-label style="color:red" *ngIf="applicantForm.get('physicalState').value == ''">State/US territory/freely associated state*</mat-label>
                    <mat-label *ngIf="applicantForm.get('physicalState').value != ''">State/US territory/freely associated state</mat-label>
                    <mat-select formControlName="physicalState" aria-describedby="physicalAddressLabel">
                      <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                    </mat-select>
                    <mat-error role="alert" *ngIf="applicantForm.get('physicalState').invalid">
                      Error: Please select a state
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:w-[20%]">
                    <input matInput placeholder="Zip" formControlName="physicalZip" aria-describedby="physicalAddressLabel">
                    <mat-error role="alert" *ngIf="applicantForm.get('physicalZip').hasError('required')">
                      Error: Please provide a zipcode
                    </mat-error>
                    <mat-error role="alert" *ngIf="applicantForm.get('physicalZip').hasError('pattern')">
                      Error: Zipcode should match this format: 99999 or 99999-1234
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field *ngIf="applicantForm.get('physicalState').value === 'OR'" class="w-full md:w-[20%]">
                    <mat-label>County</mat-label>
                    <mat-select formControlName="physicalCounty" aria-describedby="physicalAddressLabel">
                      <mat-option>-- None --</mat-option>
                      <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="m-t-8 flex flex-col">
                <div class="flex flex-col md:flex-row gap-6">
                  <span id="mailingAddressLabel" class="f-s-16"><strong>Mailing Address</strong></span>
                  <mat-checkbox formControlName="mailingIsPhysical" (change)="mailingIsSame()">
                    Same as physical
                  </mat-checkbox>
                </div>
                <div [@slideInOut] *ngIf="!applicantForm.get('mailingIsPhysical').value" class="flex flex-col">
                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[50%]">
                      <input matInput placeholder="Street Apt/Unit/Suite" formControlName="mailingStreet"
                        (blur)="validateMailingStreet()" aria-describedby="mailingAddressLabel">
                      <mat-error role="alert" *ngIf="validateMailingStreet()">
                        Error: Please provide a street
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[50%]">
                      <input matInput placeholder="City" formControlName="mailingCity" (blur)="validateMailingCity()" aria-describedby="mailingAddressLabel">
                      <mat-error role="alert" *ngIf="validateMailingCity()">
                        Error: Please provide a city
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full">
                      <mat-label>State/US territory/freely associated state</mat-label>
                      <mat-select formControlName="mailingState" (blur)="validateMailingState()" aria-describedby="mailingAddressLabel">
                        <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                      </mat-select>
                      <mat-error role="alert" *ngIf="validateMailingState()">
                        Error: Please provide a state, US territory or freely associated state
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput placeholder="Zip" formControlName="mailingZip" (blur)="validateMailingZip()" aria-describedby="mailingAddressLabel">
                      <mat-error role="alert" *ngIf="validateMailingZip()">
                        Error: Please provide a zipcode
                      </mat-error>
                      <mat-error role="alert" *ngIf="applicantForm.get('mailingZip').hasError('pattern')">
                        Error: Zipcode should match this format: 99999 or 99999-1234
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field *ngIf="applicantForm.get('mailingState').value === 'OR'" class="w-full md:w-[20%]">
                      <mat-label>County</mat-label>
                      <mat-select formControlName="mailingCounty" aria-describedby="mailingAddressLabel">
                        <mat-option>-- None --</mat-option>
                        <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <app-residential-history *ngIf="showResidentialHistory" [applicantId]="workerLicense.applicants[0]?.id"
                [residentialHistory]="workerLicense.applicants[0]?.residentialHistory">
              </app-residential-history>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="workerLicense.isRenewal">
            <div class="flex flex-row">
              <div class="flex flex-col gap-2">
                <mat-checkbox id="applicantPageCorrect" formControlName="applicantPageCorrect">
                  <span class="f-s-16">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my
                  application or revocation of my license.</span>
                </mat-checkbox>
                <mat-error role="alert" *ngIf="validateApplicantPageCorrect()">
                    Error: This is required
                </mat-error>
              </div>
            </div>
            <div class="flex flex-row">
              <div class="flex flex-col">
                 <mat-form-field>
                  <textarea rows="2" matInput placeholder="Please list any information on this page that is outdated or incorrect, but you are unable to change" formControlName="applicantPageCorrectReason" aria-describedby="applicantPageCorrect"></textarea>
                 </mat-form-field>
                 <span class="text-wrap">You are required to submit a Change Request to update the information you listed above. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
              </div>
            </div>
          </mat-card>
        </div>
      </form>
      <div class="m-t-16 flex flex-row gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Save and Back</button>
        <button mat-raised-button matStepperNext>Save and Continue</button>
      </div>
    </mat-step>
    <!-- End of Personal Information -->

    <!-- Start of Documents -->
    <mat-step [stepControl]="applicantForm" *ngIf="workerLicenses.length >= 1">
      <form [formGroup]="applicantForm">
        <ng-template matStepLabel>
          <span *ngIf="(workerLicense.applicants[0].applicantDocuments.length < 1 && applicantForm.touched) || validateDocumentPageCorrect()"
            class="text-red-400">Documents (Incomplete) </span>
          <span
            *ngIf="(workerLicense.applicants[0].applicantDocuments.length >= 1 || !applicantForm.touched) && !validateDocumentPageCorrect()">Documents</span>
        </ng-template>

        <div class="flex flex-col gap-2">
          <div class="p-b-8 flex flex-row gap-2">
            <div class="p-b-8 flex flex-col gap-2">
              <span class="f-s-20">Identity Verification</span>
              <span class="f-s-16">You must upload a copy of the <strong><i>front and back</i></strong> of a valid, unexpired government-issued
                photo identification. Accepted identification includes:</span>
              <span class="p-l-24">
                <strong>* </strong>Passport
              </span>
              <span class="p-l-24">
                <strong>* </strong>Driver license, whether issued by the State of Oregon or by another state of the
                United States - <i>front and back</i>;
              </span>
              <span class="p-l-24">
                <strong>* </strong>Identification card issued under ORS 807.400 - <i>front and back</i>;
              </span>
              <span class="p-l-24">
                <strong>* </strong>United States military identification card - <i>front and back</i>;
              </span>
              <span class="p-l-24">
                <strong>* </strong>An identification card issued by a federally recognized Indian tribe with photo, name
                and date of birth - <i>front and back</i>; or any other identification card issued by a state or territory that bears a picture
                of the person, the name of the person, the person’s date of birth and a physical description of the
                person - <i>front and back</i>.
              </span>
            </div>
          </div>

            <div class="documents-layout flex flex-col lg:flex-row gap-4">
              <div class="upload-document-panel flex flex-col gap-2 w-full lg:w-[35%]">
              <span class="f-s-20">Upload Identity Document</span>
              <div class="p-t-8 flex flex-col gap-2">
                <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="uploadApplicantDocument($event)" #fileUpload />
                <div class="flex flex-row gap-2">
                  <div class="file-upload">
                    <button [disabled]="workerLicense.status !== sharedService.pending && workerLicense.status !== sharedService.pendingRenewal" mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">
                      Browse
                      <mat-icon>attach_file</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-2 w-full">
              <span class="f-s-20">Current Documents</span>
              <div *ngIf="workerLicense.applicants[0].applicantDocuments.length != 0" class="current-document-list flex flex-col gap-2">
                <div *ngFor="let document of workerLicense.applicants[0].applicantDocuments" class="current-document-row flex flex-col sm:flex-row gap-2 justify-start items-start sm:items-center">
                  <div class="document-actions flex flex-row shrink-0">
                    <button mat-icon-button class="m-8" (click)="downloadDocument(document.id, document.name, true)"
                      color="primary" aria-label="Download File">
                      <mat-icon>save_alt</mat-icon>
                    </button>
                    <button mat-icon-button class="m-8" *ngIf="workerLicense.status == sharedService.pending"
                      (click)="deleteFile(document.id, document.name, true)" color="warn" aria-label="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  <div class="document-details flex flex-col gap-1 f-s-16">
                    <span class="sm:hidden"><strong>Document Type</strong></span>
                    <div *ngFor="let type of document.types">
                      <div *ngFor="let docType of documentTypes">
                        <span *ngIf="docType.id == type"> {{docType.type}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="document-name flex flex-col gap-1 f-s-16" title="{{document.name}}">
                    <span class="sm:hidden"><strong>File Name</strong></span>
                    <strong>{{document.name}}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <mat-card *ngIf="workerLicense.isRenewal">
        <div class="flex flex-row">
          <div class="flex flex-col gap-2">
            <form [formGroup]="documentForm">
              <mat-checkbox id="documentPageCorrect" formControlName="documentPageCorrect">
                <span class="f-s-16">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information,
                or withholding information is grounds for denial of my application or revocation of my license.</span>
              </mat-checkbox>
              <mat-error role="alert" *ngIf="validateDocumentPageCorrect()">
                  Error: This is required
              </mat-error>
            </form>
          </div>
        </div>
      </mat-card>
      <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <!-- End of Documents -->

    <!-- Start of Fees-->
    <mat-step *ngIf="workerLicenses.length >= 1">
      <ng-template matStepLabel>
        <span>Fee Information</span>
      </ng-template>
      <div class="flex flex-col gap-2 w-full lg:w-1/2">
        <app-payment-notice [canPay]="false" [entityType]="paymentService.WorkerPermitPaymentOption"
          [feeType]="paymentService.applicationFeeType" [renewal]="workerLicense.isRenewal"></app-payment-notice>
      </div>
      <div class="flex flex-row gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <!-- End of Fees-->

    <!-- Start of Review-->
    <mat-step [stepControl]="licenseForm" *ngIf="workerLicenses.length >= 1">
      <form [formGroup]="licenseForm">
        <ng-template matStepLabel>Review and Submit</ng-template>
        <mat-card>
          <mat-card-title>
            <span>Review Your Application</span>
          </mat-card-title>
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-col 2xl:flex-row gap-2">
                <mat-card class="w-full 2xl:w-1/2">
                  <mat-card-title>
                    Name and Address
                  </mat-card-title>
                  <mat-card-content>
                    <div class="flex flex-col gap-2 f-s-16">
                      <div class="flex flex-col lg:flex-row gap-2">
                        <span class="w-[0%] lg:w-[20%]"><strong>Name:</strong></span>
                        <span>{{workerLicense.applicants[0].legalFirstName}} {{workerLicense.applicants[0].legalMiddleName}} {{workerLicense.applicants[0].legalLastName}}</span>
                        <span></span>
                        <span></span>
                      </div>
                      <div class="flex flex-col lg:flex-row gap-2">
                        <span class="w-[0%] lg:w-[20%]"><strong>Physical Address</strong></span>
                        <div class="flex flex-row gap-1">
                          <span>{{workerLicense.applicants[0].physicalStreet}}</span>
                          <span>{{workerLicense.applicants[0].physicalCity}},</span>
                          <span>{{workerLicense.applicants[0].physicalState}}</span>
                        </div>
                        <div class="flex flex-row gap-1">
                          <span>{{workerLicense.applicants[0].physicalZip}}</span>
                          <span>{{workerLicense.applicants[0].physicalCounty}}</span>
                          <span *ngIf="workerLicense.applicants[0].physicalCounty">County</span>
                        </div>
                      </div>
                      <div *ngIf="!workerLicense.applicants[0].mailingIsPhysical" class="flex flex-col lg:flex-row gap-2">
                        <span class="w-[0%] lg:w-[20%]"><strong>Mailing Address</strong></span>
                        <div class="flex flex-row gap-1">
                          <span>{{workerLicense.applicants[0].physicalStreet}}</span>
                          <span>{{workerLicense.applicants[0].physicalCity}},</span>
                          <span>{{workerLicense.applicants[0].physicalState}}</span>
                        </div>
                        <div class="flex flex-row gap-1">
                          <span>{{workerLicense.applicants[0].physicalZip}}</span>
                          <span>{{workerLicense.applicants[0].physicalCounty}}</span>
                          <span *ngIf="workerLicense.applicants[0].physicalCounty">County</span>
                        </div>
                      </div>
                      <div *ngIf="workerLicense.applicants[0].mailingIsPhysical" class="flex flex-col lg:flex-row gap-2">
                        <span class="w-[0%] lg:w-[20%]"><strong>Mailing Address</strong></span>
                        <span>Same As Physical</span>
                      </div>
                      <div class="flex flex-col lg:flex-row gap-2">
                        <span class="w-[0%] lg:w-[20%]"><strong>DOB:</strong></span>
                        <span>{{workerLicense.applicants[0].dob | date}}</span>
                      </div>
                      <div class="flex flex-col lg:flex-row gap-2">
                        <span class="w-[0%] lg:w-[20%]"><strong>Contact Information</strong></span>
                        <div class="flex flex-col min-w-0">
                          <div class="flex flex-col sm:flex-row gap-2 min-w-0">
                            <span>Email:</span>
                            <span style="min-width: 0; overflow-wrap: anywhere; word-break: break-word;">{{workerLicense.applicants[0].email}}</span>
                          </div>
                          <div class="flex flex-row gap-2">
                            <span>Phone:</span>
                            <span>{{workerLicense.applicants[0].phone | mask: '(000) 000-0000 000000'}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="w-full lg:w-1/2">
                  <mat-card-title>
                    Documents
                  </mat-card-title>
                  <mat-card-content>
                    <mat-table [dataSource]="documentSource" matSort #documentSort="matSort" aria-describedby="documents"
                    class="mat-elevation-z8 m-b-0">
                    <ng-container matColumnDef="name">
                      <mat-header-cell *matHeaderCellDef mat-sort-header class="f-s-16">Name</mat-header-cell>
                      <mat-cell *matCellDef="let document">
                        <span class="f-s-16" title="{{document.name}}">
                          {{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}
                        </span>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="type">
                      <mat-header-cell *matHeaderCellDef mat-sort-header class="f-s-16">Types</mat-header-cell>
                      <mat-cell *matCellDef="let document">
                        <div class="flex flex-col f-s-16">
                          <span *ngFor="let type of document.types">
                            <span>{{documentTypeReference[type]}}</span>
                          </span>
                        </div>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="documentColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: documentColumns"></mat-row>
                  </mat-table>
                  <mat-paginator [pageSizeOptions]="[5, 10, 20]" #documentPaginator="matPaginator">
                  </mat-paginator>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="flex flex-row">
                <mat-card class="w-full lg:w-1/2">
                  <mat-card-title>
                    Signature and Acknowledgments
                  </mat-card-title>
                  <mat-card-content>
                    <div class="flex flex-col gap-4">
                      <div class="p-t-24 flex flex-col gap-4 f-s-16">
                        <ul class="flex flex-col gap-2">
                          <li class="f-s-16">
                            I certify the information provided in this application is true and complete to
                            the best of my knowledge.
                            I understand falsifying an application, supplying misleading information, or withholding information
                            is grounds for denial of my
                            application or revocation of my permit.
                          </li>
                          <li class="f-s-16">
                            I understand I am responsible for making my own determination regarding the legal
                            risks associated with a
                            Schedule 1 substance under the Federal Controlled Substances Act.
                          </li>
                          <li class="f-s-16">
                            I understand the information provided in application materials, including applicant name, is subject to disclosure
                            under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.
                          </li>
                          <li class="f-s-16">
                            I understand the following information in the application will be used by Oregon
                            Psilocybin Services to start the background
                            check process: legal name; date of birth; physical address; phone number; email address; proof of
                            identity; prior addresses if lived out of state during the past five years; social
                            security number (if consented); and prior names and aliases.
                          </li>
                          <li class="f-s-16">
                            I understand I must complete and pass a background check as a condition of being
                            granted a worker permit.
                          </li>
                          <li class="f-s-16">
                            I understand I must notify Oregon Psilocybin Services in writing within 10
                            business days of any conviction for any misdemeanor
                            or felony committed and I will be required to undergo another criminal background check.
                          </li>
                          <li class="f-s-16">
                            I understand I must notify Oregon Psilocybin Services in writing within 10
                            business days of a change in contact information.
                          </li>
                          <li class="f-s-16">
                            I have read, understand, and agree to adhere to the Oregon Psilocybin Services
                            Revised Statutes (ORS) Chapter 475A, Oregon
                            Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or
                            laws.
                          </li>
                          <li class="f-s-16">
                            I understand that failure to adhere to these statutes and rules may result in
                            denial of my application or disciplinary
                            action against any future permits issued by Oregon Psilocybin Services.
                          </li>
                          <li class="f-s-16" *ngIf="showOregonResidency(workerLicense.applicationDate)">
                            I understand the psilocybin worker permit has a term of five years from the
                            effective date of approval. If I wish to
                            renew my worker permit after that term, l must complete a renewal application.
                          </li>
                          <li class="f-s-16" *ngIf="!showOregonResidency(workerLicense.applicationDate)">
                            I understand the psilocybin worker permit has a term of one year from the
                            effective date of approval. If I wish to
                            renew my worker permit after that term, l must complete a renewal application.
                          </li>
                          <li class="f-s-16">
                            I understand a worker permit will not be issued until the worker permit fee has
                            been paid and has cleared. I understand
                            that I may not perform the duties described in ORS 475A.445until the effective date of approval.
                          </li>
                          <li class="f-s-16">
                            I understand the worker permit fee is non-refundable.
                          </li>
                        </ul>


                        <mat-checkbox [checked]="licenseForm.get('attestation').value" formControlName="attestation">
                          <strong class="f-s-16" [ngClass]="licenseForm.get('attestation').value? '' : 'text-red-400'" class="text-wrap f-s-16">I have read and I understand the above statements.</strong>
                        </mat-checkbox>
                      </div>

                      <div class="flex flex-col gap-2">
                        <span><strong>Name or Initials</strong></span>
                        <div class="flex flex-row">
                          <mat-form-field class="lg:w-1/3 sm:w-full">
                            <input matInput placeholder="Signature" formControlName="electronicSignature">
                          </mat-form-field>
                        </div>
                        <div>
                           <button mat-raised-button color="primary" type="button" (click)="submitApplication()" *ngIf="!workerLicense.isRenewal"
                            [disabled]="!licenseForm.valid || !applicantForm.valid || workerLicense.applicants[0].applicantDocuments.length < 1">
                            Submit Application
                          </button>
                          <button mat-raised-button color="primary" type="button" (click)="submitApplication()" *ngIf="workerLicense.isRenewal"
                            [disabled]="!licenseForm.valid || !applicantForm.valid || workerLicense.applicants[0].applicantDocuments.length < 1 || !documentForm.valid">
                            Submit Renewal Application
                          </button>
                        </div>
                      </div>
                      <span class="text-red-400" *ngIf="!applicantForm.valid && !applicantForm.disabled">Applicant Information is incomplete</span>
                      <span class="text-red-400" *ngIf="workerLicense.applicants[0].applicantDocuments.length < 1 && viewEdit">You need to upload proof of identity</span>
                      <span class="text-red-400" *ngIf="!licenseForm.valid && !licenseForm.disabled">You need to complete the signature and acknowledgments section</span>
                      <span class="text-red-400" *ngIf="!documentForm.valid && !documentForm.disabled">You need to complete the documents section</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </mat-step>
    <!-- End of Review-->
  </mat-stepper>
</div>

<!-- After Submit Confirmation-->
<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.red" *ngIf="renewalErrorSubmitting">
  <mat-card-content>
    <div style="color: #303030" class="flex flex-row gap-2 justify-start items-center">
      <mat-icon class="medium-icon m-24">badge</mat-icon>
      <span class="f-s-20 flex-1">Error Submitting Renewal</span>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="renewalErrorSubmitting">
  <mat-card-content>
    <span class="f-s-16">We were unable to submit your worker permit application. If this error persists please contact support.</span>
  </mat-card-content>
</mat-card>

<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.red" *ngIf="showConfirmed">
  <mat-card-content>
    <div style="color: #303030" class="flex flex-row gap-2 justify-start items-center">
      <mat-icon class="medium-icon m-24">badge</mat-icon>
      <span class="f-s-20 flex-1">{{pageTitle()}}</span>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="showConfirmed">
  <mat-card-content>
    <span class="f-s-16">Thank you for submitting the Oregon Psilocybin Services worker permit application. You can review your application status
      and updates to the status in TLC. Please be sure to monitor your email for follow-up communication from the Oregon Psilocybin Services
      Licensing Team. To ensure you receive emails from OPS, please consider adding Licensing.Psilocybin&#64;oha.oregon.gov to your email contacts to
      prevent the email going to your spam folder. </span>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="showConfirmed || renewalErrorSubmitting">

  <mat-card-content>
    <div class="flex flex-col gap-2 justify-center items-center">
      <app-payment-notice *ngIf="showConfirmed" [canPay]="false" [entityType]="paymentService.WorkerPermitPaymentOption"
        [feeType]="paymentService.applicationFeeType" [id]="workerLicense.id" [renewal]="workerLicense.isRenewal"></app-payment-notice>

      <div class="flex flex-row gap-2 justify-center items-center">
        <button mat-raised-button color="primary" type="button" (click)="continue()">Continue</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<!-- After Submit Lists-->
<div *ngIf="showSubmitted">
  <div>
    <button *ngIf="showStartButton && canApplyAgain" mat-flat-button type="button" color="primary" (click)="startApplication()">Start New Application</button>
  </div>
  <div class="flex flex-col gap-2">
    <div *ngFor="let program of workerLicenses">
      <mat-card [style.background]="cardColor" class="w-full lg:w-[40%]">
        <mat-card-content>
          <div class="flex flex-col lg:flex-row gap-6">
            <div class="flex flex-col gap-2 justify-center flex-1">
              <div class="flex flex-row justify-start items-center">
                <span class="w-[40%] f-s-16"><strong>Permit Holder</strong></span>
                <div class="flex flex-row gap-2">
                  <span class="f-s-18">{{program.applicants[0].legalFirstName}}</span>
                  <span class="f-s-18">{{program.applicants[0].legalLastName}}</span>
                </div>
              </div>
              <div class="m-b-0 flex flex-row justify-start items-center" style="height: 25pt">
                <span class="w-[40%] f-s-16"><strong>Permit Id</strong></span>
                <span class="f-s-16" id="programId">{{program.licenseId}}</span>
                <button mat-icon-button (click)="sharedService.copyToClipboard(program.licenseId)" color="primary"
                  matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>

              <div class="flex flex-row justify-start items-center">
                <span class="w-[40%] f-s-16"><strong>Status</strong></span>
                <div class="flex flex-col">
                  <span class="f-s-20 f-w-700" [ngClass]="program.status === sharedService.approved? 'text-light-green-600':
                                  (program.status === sharedService.submitted ||
                                  program.status === sharedService.pending ||
                                  program.status === sharedService.underReview)? 'text-orange-900' : 'text-red-900'" *ngIf="program.status != sharedService.submittedForApproval">
                    {{program.status}}
                  </span>
                  <span class="f-s-20 f-w-700" [ngClass]="'text-orange-900'" *ngIf="program.status == sharedService.submittedForApproval">{{sharedService.underReview}}</span>
                </div>
              </div>
              <div *ngIf="program.status === sharedService.submitted || (program.status === sharedService.closed && program.applicationDate)"class="flex flex-row">
                <span class="w-[40%] f-s-16"><strong>Date Submitted</strong></span>
                <span class="f-s-18">{{program.applicationDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.closed" class="flex flex-row">
                <span class="w-[40%] f-s-16"><strong>Closed Date</strong></span>
                <span class="f-s-18">{{program.closedDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.approved" class="flex flex-row">
                <span class="w-[40%] f-s-16"><strong>Date Approved</strong></span>
                <span class="f-s-18">{{program.approvedDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.approved || program.status === sharedService.expired" class="flex flex-row">
                <span class="w-[40%] f-s-16"><strong>Expiration Date</strong></span>
                <span class="f-s-18">{{program.expirationDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.approved && program.isRenewal" class="flex flex-row">
                <span class="w-[40%] lg:w-[40%] f-s-16"><strong>Date Renewal Approved</strong></span>
                <span class="f-s-18">{{program.renewedDate | date}}</span>
              </div>
              <div *ngIf="program.status == 'Approved, Pending Payment and Clearance'|| program.status == 'Approved'" class="flex flex-row">
                <span class="w-[40%] f-s-16"><strong>Payment Status</strong></span>
                <span [ngClass]="hasPaidApplicationFee(program) ? 'text-light-green-600':  'text-red-900'">
                  <span class="f-s-18">{{getPaymentFeeStatus(program)}}</span>
                </span>
              </div>
              <div *ngIf="hasPaidApplicationFee(program)" class="flex flex-row">
                <span class="w-[40%] f-s-16"><strong>Payment Cleared</strong></span>
                <span class="f-s-18">{{getapplicationClearedDate(program)}}</span>
              </div>
            </div>

            <div class="flex flex-col gap-2 justify-center items-start">
              <button *ngIf="program.status !== sharedService.pendingRenewal && program.status !== sharedService.renewalSubmitted && !program.isRenewal"
                mat-flat-button type="button" color="primary" (click)="editApplication(program)">
                <div *ngIf="showEditLoading" class="flex flex-row gap-2">
                  <span>Loading</span>
                  <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                </div>
                <span *ngIf="!showEditLoading && program.status != 'Pending' && program.status != 'Pending Renewal'">View</span>
                <span *ngIf="!showEditLoading && (program.status == 'Pending' || program.status == 'Pending Renewal')">Edit</span>
              </button>
              <button *ngIf="program.isRenewal" mat-flat-button type="button" color="primary" (click)="viewRenewal(program)">
                <div *ngIf="showEditLoading" class="flex flex-row gap-2">
                  <span>Loading</span>
                  <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                </div>
                <span *ngIf="program.status === sharedService.pendingRenewal">Continue Renewal</span>
                <span *ngIf="program.status !== sharedService.pendingRenewal">View</span>
              </button>
              <button *ngIf="program.status == 'Submitted'" mat-flat-button type="button" color="accent"
                (click)="requestWithdraw(program)">Request Withdraw
              </button>
              <button *ngIf="program.canRenew && !hasRenewal(program) && program.status == sharedService.approved && !startedRenewal"
                mat-flat-button type="button" color="accent" (click)="createRenewal(program)">
                <span>Start Renewal</span>
              </button>
              <button *ngIf="program.status == 'Approved'" mat-flat-button type="button" color="accent"
                (click)="requestSurrender(program)">Request Surrender
              </button>
              <a  *ngIf="(hasUnpaidFees(program) && (program.status == sharedService.awaitingPayment || program.status == sharedService.renewalAwaitingPayment)) || hasCivilPenaltyFee(program)" mat-flat-button type="button" color="warn" routerLink="/payments">Pay Fee</a>
              <button  color="primary" *ngIf="program.status == 'Approved'" mat-flat-button (click)="viewWorkerLicenseDetails(program)">Print Permit</button>
            </div>

            <div *ngIf="program.status == 'Approved'" class="flex flex-col gap-2 justify-center items-start">
              <a [routerLink]="['/license-information/WorkerPermit', program.id]">
                <qrcode [qrdata]=" url + '/license-information/WorkerPermit/'+ program.id"></qrcode>
              </a>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="loading">
  <div [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h2>Loading</h2>
  </div>
</div>
